import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '../lib/api'
import type {
  MarkirovkaStockResponse,
  MarkirovkaGtinMarksResponse,
} from '../types/markirovka-stock.types'

const STOCK_QUERY_KEY = 'markirovka-stock'

/** Список GTIN организации с количеством КМ на остатках. */
export const useMarkirovkaStock = () => {
  return useQuery({
    queryKey: [STOCK_QUERY_KEY],
    queryFn: async (): Promise<MarkirovkaStockResponse> => {
      return apiClient.getMarkirovkaStock()
    },
    staleTime: 60 * 1000, // совпадает с TTL кэша на бэке
    retry: 1,
  })
}

/** Детализация КМ по конкретному GTIN. Запрос включается, когда gtin задан. */
export const useMarkirovkaGtinMarks = (gtin: string | null) => {
  return useQuery({
    queryKey: [STOCK_QUERY_KEY, 'marks', gtin],
    queryFn: async (): Promise<MarkirovkaGtinMarksResponse> => {
      return apiClient.getMarkirovkaGtinMarks(gtin as string)
    },
    enabled: !!gtin,
    staleTime: 60 * 1000,
    retry: 1,
  })
}

/**
 * Ручной запуск синхронизации остатков из edo (фоновая на бэке).
 * После запуска обновляем список из БД через небольшую задержку.
 */
export const useTriggerMarkirovkaStockSync = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async () => apiClient.triggerMarkirovkaStockSync(),
    onSuccess: () => {
      // Синхронизация идёт в фоне — перечитываем БД с задержкой.
      setTimeout(() => {
        void queryClient.invalidateQueries({ queryKey: [STOCK_QUERY_KEY] })
      }, 4000)
    },
  })
}
